import gsap from 'gsap'

const overlay = document.querySelector('.signup-overlay')
const form = document.querySelector('#signupForm')
const headding = document.querySelector('.overlay-heading')
const message = document.querySelector('.form-message')
let overlayOpen = false
let isSendingRequest = false

//Content
const formContent = `<div class="form-group">
              <input
                type="text"
                id="company"
                name="company"
                placeholder="Company"
                required
              />
            </div>
            <div class="form-group">
              <!-- <label for="name">Name</label> -->
              <input
                type="text"
                id="name"
                placeholder="Name"
                name="name"
                required
              />
            </div>
            <div class="form-group">
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                required
              />
            </div>

            <div class="form-group">
              <textarea
                id="message"
                name="message"
                rows="4"
                placeholder="Message"
                required
              ></textarea>
            </div>

            <div class="btn-block">
              <a class="form-btn" onclick="closeOverlay()">Cancel</a>
              <button class="form-btn" type="submit">OK</button>
            </div>`;
const formUnsuccess = `<h2 class='text-center'>Sorry, there was an error</h2> <p style="margin-top: 18px;">We'll fix that shortly!</p>`;
const formSuccess = `<h2 class='text-center text-green-600 font-bold text-xl'>Message sent successfully!</h2> <p style="margin-top: 18px;">We'll get in touch with you shortly</p> <a style="display: block; margin-top:30px" class="form-btn" onclick="closeOverlay()">Close</a>`;

const overlayTL = gsap.timeline({
  paused: true
})

overlayTL.to('.signup-overlay', {
  autoAlpha: 1,
  duration: .5,
  ease: 'power2.inOut'
})
overlayTL.fromTo('.signup-form', {
  autoAlpha: 0,
  y: -100
}, {
  y: 0,
  autoAlpha: 1,
  duration: .75,
  ease: 'power3.out'
}, .125);

function openOverlay() {
  overlayOpen = true
  form.style.display = 'block'
  overlayTL.timeScale(2).play()
}

function closeOverlay() {
  overlayOpen = false
  overlayTL.timeScale(3).reverse()
}

window.signupBtn = signupBtn;
window.closeOverlay = closeOverlay;

if (location.href.split('#')[1] === 'signup') {
  signupBtn()
}

function signupBtn() {
  console.log('clicked')
  if (isSendingRequest) return
  openOverlay()
  message.style.display = 'none'
  headding.style.display = 'block'
  form.innerHTML = formContent
  if (overlayOpen)
    document.onkeydown = function (e) {
      if (e.key === "Escape")
        closeOverlay()
    };
  form.addEventListener('submit', handleForm)
}


function handleForm(e) {
  console.log('send req')
  e.preventDefault()
  form.innerHTML = `<svg class="animate-spin mx-auto h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>`

  const formData = new FormData(e.target);
  const endpoint = "https://app.nodety.com/backend/website_signup";
  const datas = {
    name: formData.get("message"),
    email: formData.get("email"),
    company: formData.get("company"),
    comment: formData.get("message"),
  };

  fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(datas)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      form.style.display = 'none'
      headding.style.display = 'none'
      message.style.display = 'block'
      message.innerHTML = formSuccess
      form.removeEventListener('submit', handleForm)
    })
    .catch(error => {
      console.error('Error:', error);
      message.style.display = 'block'
      message.innerHTML = formUnsuccess
      form.removeEventListener('submit', handleForm)
    });
}